import { axiosWithAuth } from '../../utilities';

const baseUrl = `${process.env.CARVANA_APP_CONTACTS_API_URL}/v2`;
export default class ContactsApi {
  static updateContactsDetails(modifyContactPayload: Record<string, unknown>) {
    const endpoint = `${baseUrl}/details`;
    return axiosWithAuth({ timeout: 20000 }).put(endpoint, modifyContactPayload);
  }

  static validateZip5(zip5: string) {
    const endpoint = `${process.env.CARVANA_APP_CONTACTS_API_URL}/v1/details/addresses/validate-zip5/${zip5}`;
    return axiosWithAuth({ timeout: 20000 }).get(endpoint);
  }
}
